import DatePicker from 'react-datepicker';
import { Box, Flex, Input } from '@cmpsr/components';
import { displayDateFormatWithDay } from '@/constants/dates';
import 'react-datepicker/dist/react-datepicker.css';
import customTheme from '@/constants/theme.custom';
import IconCatch from '@/components/icons/icon-catch/icon-catch';
import { useTargetDate, UseTargetDateProps } from './target-date.controller';

export default function TargetDate(props: UseTargetDateProps) {
  const { selectedDate, handleDateChange } = useTargetDate(props);

  return (
    <Flex position="relative" alignItems="center" mb="4" width="fit-content" maxWidth="300px">
      <Flex
        position="relative"
        p="2"
        border="1px solid"
        borderColor={selectedDate ? 'ui-element-divider' : customTheme.colors.lightBlue}
        borderRight="none"
        backgroundColor={selectedDate ? 'background-page' : customTheme.colors.lightBlue}
        borderTopLeftRadius="radii-2"
        borderBottomLeftRadius="radii-2"
        h="40px"
        alignItems="center"
      >
        <IconCatch icon="Calendar-Add" size="xs" color={'text-primary'} bgColor="transparent" />
      </Flex>
      <Box
        width="fit-content"
        border="1px solid"
        borderColor="ui-element-divider"
        borderLeft="none"
        borderTopRightRadius="radii-2"
        borderBottomRightRadius="radii-2"
        bgColor="background-page"
        h="40px"
      >
        <DatePicker
          selected={selectedDate}
          onChange={handleDateChange}
          dateFormat={displayDateFormatWithDay}
          placeholderText="Set target date"
          customInput={<Input border="none" backgroundColor="transparent" maxW="160px" />}
        />
      </Box>
    </Flex>
  );
}
